import React, { useEffect } from 'react';
import DialogComponent from './dialogComponent';
import LogUtils from 'utils/logUtils';
import { DialogType } from 'enum';

/***********************************************************************
 * 型定義
 ***********************************************************************/
/**
 * ダイアログコンポーネント引数
 * @name LoadingDialogComponentProp
 */
export type LoadingDialogComponentProp = {
  open: boolean;
};
/***********************************************************************
 * Style
 ***********************************************************************/

/***********************************************************************
 * メイン処理
 ***********************************************************************/
/**
 * ダイアログコンポーネント
 * @name LoadingDialogComponent
 */
const LoadingDialogComponent: React.FC<LoadingDialogComponentProp> = ({
  open,
}) => {
  /**
   * クラス名
   * @name className
   * @member
   */
  const className = 'LoadingDialogComponent';

  /**
   * 副作用フック
   * @name useEffect
   * @function
   */
  useEffect(() => {
    /**
     * 初期設定処理
     * @name init
     * @event
     */
    const init = async () => {
      const methodName = 'init';
      try {
        LogUtils.info(`${className} ${methodName} start`);
        LogUtils.info(`${className} ${methodName} end`);
      } catch (e) {
        LogUtils.info(`${className} ${methodName} Error: ${e}`);
      }
    };
    init();
  }, []);

  /***********************************************************************
   * 画面の定義
   ***********************************************************************/
  return (
    <DialogComponent
      dialogType={DialogType.Loading}
      message={''}
      open={open}
      onCloseClick={() => {
        // 処理なし
      }}
    ></DialogComponent>
  );
};

export default LoadingDialogComponent;
